import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  useEffect(() => {
    if (showTerms) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showTerms]);
  return <>
      <footer className="w-full bg-teal-dark py-16 px-6 flex flex-col items-center justify-center text-center" data-id="element-97">
        <Logo color="#FFFFFF" size={48} showText={false} className="mb-8" data-id="element-98" />

        <div className="flex items-center justify-center flex-wrap gap-4 text-white/90 font-light tracking-wide mb-10" data-id="element-99">
          <a href="https://instagram.com/laurazalazar.llavesdetualma" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-100">
            Instagram
          </a>
          <span data-id="element-101">·</span>
          <a href="https://www.facebook.com/profile.php?id=61582757763423&locale=es_LA" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-102">
            Facebook
          </a>
          <span data-id="element-103">·</span>
          <button onClick={() => setShowTerms(true)} className="hover:text-gold transition-colors cursor-pointer" data-id="element-104">
            Términos y Condiciones
          </button>
        </div>

        <div className="text-white/60 font-light text-sm leading-relaxed mb-12" data-id="element-105">
          Las Llaves de Tu Alma · Laura
          <br data-id="element-106" />
          Todas las sesiones son a distancia
          <br data-id="element-107" />
          Argentina · Para todo el mundo hispanohablante
        </div>

        <div className="text-white/40 text-xs tracking-wider" data-id="element-108">
          © {new Date().getFullYear()} Las Llaves de Tu Alma. Todos los
          derechos reservados.
        </div>
      </footer>

      <AnimatePresence data-id="element-109">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8 bg-black/60 backdrop-blur-sm" onClick={() => setShowTerms(false)} role="dialog" aria-modal="true" aria-labelledby="terms-title" data-id="element-110">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="relative bg-cream rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-111">
              <div className="flex items-center justify-between px-8 py-6 border-b border-teal/15" data-id="element-112">
                <h2 id="terms-title" className="font-serif text-teal-dark text-2xl md:text-3xl" data-id="element-113">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTerms(false)} className="text-teal-dark hover:text-teal transition-colors p-2 -mr-2" aria-label="Cerrar" data-id="element-114">
                  <X size={24} strokeWidth={1.5} data-id="element-115" />
                </button>
              </div>

              <div className="overflow-y-auto px-8 py-8 space-y-8 text-gray-700 font-light leading-relaxed" data-id="element-116">
                <p className="font-serif italic text-teal-dark text-lg" data-id="element-117">
                  Última actualización: {new Date().getFullYear()}
                </p>

                <section data-id="element-118">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-119">
                    1. Naturaleza del servicio
                  </h3>
                  <p data-id="element-120">
                    Las Llaves de Tu Alma ofrece sesiones de trabajo energético
                    a distancia mediante el Método Llave, que incluye depuración
                    del campo áurico, investigación radiestésica y, según el
                    nivel elegido, apertura de Registros Akáshicos. Las sesiones
                    son de naturaleza espiritual y energética.
                  </p>
                </section>

                <section data-id="element-121">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-122">
                    2. No reemplaza tratamiento médico ni psicológico
                  </h3>
                  <p data-id="element-123">
                    El servicio aquí ofrecido no sustituye en ningún caso
                    consultas, diagnósticos o tratamientos médicos,
                    psicológicos, psiquiátricos o de cualquier otra índole
                    profesional. Si estás bajo tratamiento, te recomendamos
                    continuar con tus profesionales de la salud y consultar con
                    ellos cualquier inquietud.
                  </p>
                </section>

                <section data-id="element-124">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-125">
                    3. Datos personales y privacidad
                  </h3>
                  <p data-id="element-126">
                    Para realizar la sesión solicito tu nombre completo, fecha
                    de nacimiento e intención. Estos datos se utilizan
                    exclusivamente para realizar el trabajo energético y se
                    tratan de manera confidencial. No se comparten con terceros.
                  </p>
                </section>

                <section data-id="element-127">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-128">
                    4. Pago y reserva del turno
                  </h3>
                  <p data-id="element-129">
                    El turno queda reservado una vez realizado el pago, que debe
                    estar acreditado antes de las 24 horas previas a la fecha
                    elegida. Pagos en Argentina mediante transferencia bancaria
                    o Mercado Pago. Pagos internacionales mediante PayPal en
                    USD.
                  </p>
                </section>

                <section data-id="element-130">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-131">
                    5. Política de cancelación
                  </h3>
                  <ul className="space-y-2 list-none" data-id="element-132">
                    <li data-id="element-133">
                      <strong className="text-teal-dark" data-id="element-134">
                        Más de 48 horas antes:
                      </strong>{' '}
                      reembolso completo o crédito para reagendar.
                    </li>
                    <li data-id="element-135">
                      <strong className="text-teal-dark" data-id="element-136">
                        Entre 48 y 24 horas antes:
                      </strong>{' '}
                      el monto queda como crédito para una futura sesión.
                    </li>
                    <li data-id="element-137">
                      <strong className="text-teal-dark" data-id="element-138">
                        Menos de 24 horas antes:
                      </strong>{' '}
                      no se realizan reembolsos.
                    </li>
                  </ul>
                  <p className="mt-3" data-id="element-139">
                    Si por razones excepcionales necesito cancelar de mi parte,
                    se ofrece reembolso completo o prioridad absoluta en el
                    reagendado.
                  </p>
                </section>

                <section data-id="element-140">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-141">
                    6. Sesiones a distancia
                  </h3>
                  <p data-id="element-142">
                    El trabajo se realiza en el plano energético, sin necesidad
                    de presencia ni videollamada. La devolución se entrega en
                    formato de audio durante la tarde del día acordado.
                  </p>
                </section>

                <section data-id="element-143">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-144">
                    7. Consentimiento del cliente
                  </h3>
                  <p data-id="element-145">
                    Las sesiones se realizan únicamente sobre el campo
                    energético de la persona que las solicita, con su
                    consentimiento expreso. No realizo trabajos sobre campos de
                    terceros sin que ellos lo hayan pedido y acordado
                    directamente.
                  </p>
                </section>

                <section data-id="element-146">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-147">
                    8. Propiedad intelectual
                  </h3>
                  <p data-id="element-148">
                    El audio de devolución es de uso personal del cliente. No
                    está permitido reproducirlo, distribuirlo, compartirlo en
                    redes sociales o utilizarlo con fines comerciales sin
                    autorización expresa.
                  </p>
                </section>

                <section data-id="element-149">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-150">
                    9. Resultados y responsabilidad
                  </h3>
                  <p data-id="element-151">
                    El proceso de integración posterior a la sesión es
                    individual y depende de cada persona. No se garantizan
                    resultados específicos en plazos determinados. Las Llaves de
                    Tu Alma no se hace responsable por decisiones, acciones o
                    consecuencias que el cliente derive de la información
                    recibida en su devolución.
                  </p>
                </section>

                <section data-id="element-152">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-153">
                    10. Aceptación
                  </h3>
                  <p data-id="element-154">
                    Al agendar y abonar una sesión, el cliente acepta los
                    presentes Términos y Condiciones en su totalidad.
                  </p>
                </section>

                <section data-id="element-155">
                  <h3 className="font-serif text-teal-dark text-xl mb-3 uppercase tracking-wider text-sm" data-id="element-156">
                    11. Jurisdicción
                  </h3>
                  <p data-id="element-157">
                    Para cualquier controversia que pudiera surgir, se aplicará
                    la legislación vigente en la República Argentina.
                  </p>
                </section>
              </div>

              <div className="px-8 py-5 border-t border-teal/15 flex justify-end" data-id="element-158">
                <button onClick={() => setShowTerms(false)} className="bg-teal text-white px-8 py-3 rounded-full font-medium tracking-wide hover:bg-teal-dark transition-colors" data-id="element-159">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}